import React,  { Component } from 'react'

// ui
import Modal from '../../../components/feedback/modal'

// select event component
import SelectEventComponent from '../../../components/select_events'

// redux
import { connect } from 'react-redux'
import ReportActions from '../../../redux/report/actions'

class ModalSelectEvent extends Component{

    _handleOK = () => {
        this.props.dismiss()
    }

    _handleCancel = () => {
        this.props.dismiss()
    }

    _userSelectEvent = (events) => {
        this.props.dismiss()
        this.props.updateSelectedEvent([])
        this.props.updateSelectedEvent(events)
    }

    render(){
        const { visible } = this.props
        let { selected_event } = this.props 
        if (!visible) selected_event = []

        return (
            <Modal
                visible = {visible}
                title = "Lựa chọn sự kiện"
                onOK={() => this._handleOK()}
                onCancel={() => this._handleCancel()}
                centered
                width={900}
                footer={
                    null
                }
            >
                <SelectEventComponent 
                    onSuccess = {(events) => this._userSelectEvent(events)}
                    onCancel = {() => this._handleCancel()}
                    initEvent = {selected_event}
                />
            </Modal>
        )
    }
}

const mapStateToProps = state => {
    return {
        visible: state.qbreport.modalSelectEventState,
        selected_event: state.qbreport.selected_event
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dismiss: () => {
            dispatch(ReportActions.action.dismissModalSelectEvent())
        },
        updateSelectedEvent: selected_event => {
            dispatch(ReportActions.action.updateSelectedEvent(selected_event))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalSelectEvent)